import TableList from "@components/templates/tablelist";
import { HttpGetBillTotalList, HttpConfirmBill } from "@/service/newbigaccount";
import { mapState, mapGetters } from "vuex";
import comExcel from '../detail/excelalert.vue'
import comIndex from './sendBill.vue'
import comTotalCost from './totalcost.vue'

export default {
    mixins:[TableList],
    components: {
        comExcel,
        comIndex,
        comTotalCost
    },
    data(){
        return {
            isMixin: true,
            Tools: {show: true},
            formData:{
                search:{
                    EQ_status:null,
                    EQ_promotionType:null,
                    IN_id:null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            exportdata:{},
        }

    },
    methods:{
        ajaxRequest: HttpGetBillTotalList,
        interceptRequest(params) {
            const { BT_startTime } = params.search;
            params.search.LE_startTime = BT_startTime;
            params.search.GE_endTime = BT_startTime;
            delete params.search.BT_startTime;
            // this.formData = params
            this.exportdata = params
            return params
        },

        handleOperates(params="", type,batch){
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "export":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/bill/export", this.exportdata,
                        {
                            executor: "request",
                            download: true,
                            method: 'get'
                        }
                    );
                break;
                case "exportDetail":
                    this.exportDetail(params.billNo);
                break;
                case 'confirm':
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: "确认账单",
                        width: 400,
                        desc: '请确认账单金额USD ' + params.totalCost +'是否准确？',
                        showDesc: true,
                        params: {
                            id: params.id,
                        },
                        ajaxRequest: HttpConfirmBill,
                    };
                break;
                case 'sendBill':
                    this.operate = {
                        title: "发送账单",
                        show: true,
                        width: 900,
                        component: "comIndex",
                        activeid: params,
                        showFooter: false,
                    };
                break;
                case 'totalCost':
                    this.operate = {
                        title: "账单汇总",
                        show: true,
                        width: 400,
                        component: "comTotalCost",
                        params: params,
                        showFooter: false,
                    };
                break;
            }
        },
        getOperateNodeMap(row){
            const { id, status, totalCost, billNo } = row
            return [
                // {
                //     label:'删除',
                //     show: true,
                //     params:id,
                //     operate:'delete'
                // },
                {
                    label:'确认账单',
                    show: status == 0,
                    params:{ id, totalCost },
                    operate:'confirm'
                },
                {
                    label: "导出明细",
                    show: true,
                    params:{ id, billNo },
                    operate:'exportDetail'
                },
                {
                    label: "发送账单",
                    show:this.handleAuth('fbb.bill.send'),
                    params: id,
                    operate: 'sendBill'
                },
            ]
        },
        exportDetail(billNo){
            const searchItem = { bill_no: billNo};
            this.handleWebfs(
                process.env.VUE_APP_APIURL_BI + "/api/v1/ReportTask/save",
                {args:JSON.stringify(searchItem), template_id: 10033},
                {
                    executor: "request",
                    download: true,
                    method: "post",
                }
            )
            .then((res) => {
                this.operate = {
                  title: '查询条件导出',
                  show: true,
                  width: 560,
                  component: "comExcel",
                  fileId: res.data.id,
                  showFooter: false
            }})
            .catch((err) => {
                // this.$VMessage.error(err.message);
            });
        }
    },
    computed: {
        ...mapGetters('dictionary',['getBillcusorgList','getBillcusWareList','getCusproductList','getCusBillTypeList']),
        ToolsData(){
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "primary",
                },
            ]

        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [

                {
                    label: "客户组织",
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    options:this.getBillcusorgList,
                    props:{
                        dropStyle,
                        filterable:true,
                    },
                    show:true,
                },
                // {
                //     label: '项目',
                //     tag: 'vSelect',
                //     key: 'EQ_lineId',
                //     options: this.getCusproductList,
                //     props:{
                //         filterable:true,
                //     },
                //     show:true,
                // },
                {
                    label: '账单编号',
                    tag: 'vInput',
                    key: 'EQ_billNo',
                    show: true,
                },
                {
                    label: '账期状态',
                    tag: 'vSelect',
                    key: 'EQ_status',
                    options: [
                        {value:0,label:'待确认'},
                        {value:1,label:'已确认'}
                    ],
                    props:{
                        filterable:true,
                    },
                },
                {
                    label: '账期',
                    tag: 'vDatepicker',
                    key: 'BT_startTime',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: '创建日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },


            ]
        },
        columns() {
            return  [
                {
                    title: '操作',
                    width: 90,
                    render:this.getOperateNodes,
                },
                {
                    title: '客户组织',
                    // render: (h, { row }) => this.findRenderLabel(this.getBillcusorgList, row.organizationId),
                    render:(h,{row})=>{
                        return <div>{row.organizationName}</div>
                    }
                },
                {
                    title: '账单编号',
                    render: (h, { row }) => {
                        return <div>{row.billNo || '--'}</div>
                    }
                },
                // {
                //     title: '项目',
                //     render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId) || '--',
                // },
                {
                    title: '账期',
                    minWidth: 160,
                    render: (h, { row }) => {
                        return <div>{row.startTime || '--'} ~ {row.endTime || '--'}</div>
                    },
                },
                {
                    title: '总费用',
                    render: (h, { row }) => {
                        return <div style="cursor:pointer; color: blue" onClick={this.handleOperates.bind(this, row, 'totalCost')}>{row.totalCost}</div>
                    }
                },
                {
                    title: '仓库作业费总额',
                    render: (h, { row }) => {
                        return <div>{row.operationCost}</div>
                    }
                },
                {
                    title: '仓储费总额',
                    render: (h, { row }) => {
                        return <div>{row.storageCost}</div>
                    }
                },
                {
                    title: '增值服务费总额',
                    render: (h, { row }) => {
                        return <div>{row.valueAddedCost}</div>
                    }
                },
                {
                    title: '调账总额',
                    render: (h, { row }) => {
                        return <div>{row.adjustmentCost}</div>
                    }
                },
                {
                    title: '配送费总额',
                    render: (h, { row }) => {
                        return <div>{row.deliveryCost}</div>
                    }
                },
                {
                    title: '币种',
                    render: (h, { row }) => {
                        return <div>{row.currency || '--'}</div>
                    }
                },
                {
                    title: '账期状态',
                    width: 150,
                    render: (h, { row }) => {
                        return <div>{row.status == 0 ? '待确认':'已确认' || '--'}</div>
                    }
                },
                {
                    title: this.$t('',{defaultValue:'确认人/确认时间'}),
                    render: (h,{row})=>{
                        return <div>
                            <div>{ row.confirmUser || '--' }</div>
                            <div>{ row.confirmAt || '--' }</div>
                        </div>
                    }
                },
                {
                    title: '创建时间',
                    render: (h, { row }) => {
                        return <div>{row.createdAt || '--'}</div>
                    }
                },
            ];
        },

    },
}

